import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '@tekman/shared/service';
import { UserService } from '@tekman/onmat/service/generic';
import { Language } from '@tekman/onmat/constants';
import { environment } from '../../../environments/environment';

const REGION_MAP: Record<string, Language> = {
  [Language.ESP]: Language.ESP,
  [Language.CAT]: Language.CAT,
  [Language.VAL]: Language.CAT,
  [Language.MEX]: Language.MEX,
  [Language.ECU]: Language.ECU,
  [Language.ENG]: Language.ENG,
};

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly storage: StorageService,
    private readonly userService: UserService
  ) {}

  private getRegion(): string {
    const user = this.userService.getUser();

    // TODO: Temporary patch for the 2026-2027 school year. Ecuador users come from the SSO
    // with region ECUADOR_COSTA, but the API expects ECU in the X-Region header.
    // Remove next year once the SSO sends the normalized region (ECU).
    if (user?.attributes?.['region'] === 'ECUADOR_COSTA') {
      return Language.ECU;
    }
    const lang = this.storage.languageLicense || Language.ESP;
    return REGION_MAP[lang.toUpperCase()] ?? lang.toLowerCase();
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = localStorage.getItem('googleAccessToken');
    if (request.url.includes('materials-api')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Basic ${btoa(environment.materials.key + ':' + environment.materials.value)}`,
        },
      });
    } else if (request.url.includes('googleapis') && accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    } else if (!request.url.startsWith(environment.coreApiV7)) {
      // The core resolves the region from the token itself and has no use for
      // `X-Region`, so it is only sent to the ONMAT API, which does need it.
      request = request.clone({
        setHeaders: { 'X-Region': this.getRegion() },
      });
    }

    return next.handle(request);
  }
}
